export default __webpack_public_path__ + "static/media/E7.1669110d.jpg";